<ng-container *ngIf="badgeCount"><span [class]="badge.type">{{ badgeCount }}</span></ng-container>
